import type { BalanceStore } from "./BalanceStore";
import type { MoneyFormatter } from "../money/MoneyFormatter";
import type { BalancePort } from "./BalancePort";

export class BalancePresenter {
  private readonly balanceStore: BalanceStore;
  private readonly formatter: MoneyFormatter;
  private readonly panel: BalancePort;

  private unsubscribe?: () => void;

  public constructor(input: { balanceStore: BalanceStore; formatter: MoneyFormatter; panel: BalancePort }) {
    this.balanceStore = input.balanceStore;
    this.formatter = input.formatter;
    this.panel = input.panel;
  }

  public start(): void {
    this.unsubscribe?.();
    // The store pushes the current snapshot on subscribe, so this renders once immediately.
    this.unsubscribe = this.balanceStore.subscribe(() => {
      this.render();
    });
  }

  public stop(): void {
    this.unsubscribe?.();
    this.unsubscribe = undefined;
  }

  public hide(): void {
    this.panel.hide();
  }

  public render(): void {
    const snap = this.balanceStore.getSnapshot();

    // format using existing MoneyContext (minor units)
    const text = this.formatter.formatMinor(snap.balanceMinor);

    this.panel.setBalanceText(text);
  }
}